export const PREV_PATH_KEY = "auth_prev_path";
export const OAUTH_CALLBACK_PATH = "/authenticated";
